define('views/pages/wishlist/wishes/modal/index',['require','jquery','underscore','chaplin','views/base/modal','./content'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        Chaplin = require('chaplin'),
        ModalView = require('views/base/modal'),
        ContentView = require('./content');

    var OrganizationModalView = ModalView.extend({
        listen: {
            'addedToDOM': 'onAddedToDOM',
            'wishlist.saved mediator': 'saved',
            'wishlist.showPreloader mediator': 'showPreloader',
            'wishlist.hidePreloader mediator': 'hidePreloader'
        },
        initialize: function() {
            ModalView.prototype.initialize.apply(this, arguments);

            $('html').addClass('modal-visible');
        },
        render: function() {
            ModalView.prototype.render.apply(this, arguments);
        },
        onAddedToDOM: function() {
            this.subview('content', new ContentView({ model: this.model.content, container: this.$modalBody }));
        },
        dispose: function() {
            if (this.disposed) { return; }

            $('html').removeClass('modal-visible');

            ModalView.prototype.dispose.apply(this, arguments);
        },
        action: function(action, cancel) {
            if (action === 'save') {
                cancel();
                this.publishEvent('wishlist.save');
            }
        },
        saved: function() {
            this.model.trigger('saved');
        }
    });

    return OrganizationModalView;
});

